// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanCodeValidationRequestDto
 */
export interface IPlanCodeValidationRequestDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanCodeValidationRequestDto
     */
    organization_id: number;
    /**
     * 
     * @type {Set<string>}
     * @memberof IPlanCodeValidationRequestDto
     */
    plan_codes: Set<string>;
}

/**
 * Check if a given object implements the IPlanCodeValidationRequestDto interface.
 */
export function instanceOfIPlanCodeValidationRequestDto(value: object): value is IPlanCodeValidationRequestDto {
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('plan_codes' in value) || value['plan_codes'] === undefined) return false;
    return true;
}

export function IPlanCodeValidationRequestDtoFromJSON(json: any): IPlanCodeValidationRequestDto {
    return IPlanCodeValidationRequestDtoFromJSONTyped(json, false);
}

export function IPlanCodeValidationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanCodeValidationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'organization_id': json['organization_id'],
        'plan_codes': new Set(json['plan_codes']),
    };
}

export function IPlanCodeValidationRequestDtoToJSON(json: any): IPlanCodeValidationRequestDto {
    return IPlanCodeValidationRequestDtoToJSONTyped(json, false);
}

export function IPlanCodeValidationRequestDtoToJSONTyped(value?: IPlanCodeValidationRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization_id': value['organization_id'],
        'plan_codes': Array.from(value['plan_codes'] as Set<any>),
    };
}

